import { CKEditor } from '@ckeditor/ckeditor5-react';
import CustomEditor from 'ckeditor5-custom-build';

type Props = {
    data: string
    onChange: (content: string) => void
    disabled?: boolean
}

const Editor: React.FC<Props> = ({
    data, onChange, disabled
}) => {
    return <CKEditor
    editor={CustomEditor}
        disabled={disabled}
      data={data}
      config={{
        toolbar: disabled ? [] : ['undo', 'redo', '|', 'alignment', 'heading', '|', 'bold', 'italic', 'underline', '|', 'link', 'bulletedList', 'numberedList', 'indent', 'outdent', '|', 'blockQuote', 'insertTable']
      }}
      onChange={ ( event, editor ) => {
          onChange(editor?.getData())
      } }
      onBlur={ ( event, editor ) => {
          onChange(editor?.getData())
      } }
  />
}

export default Editor
// #eff2f5